import { TableColumnType, Text } from '@fullstory/components';
import { intl } from '@fullstory/intl';
import { Timestamp } from '@fullstory/proto/google/protobuf';
import { FieldScope } from '@fullstory/search-vars';
import React from 'react';
import { EventRow } from './types';

export const EVENT_TABLE_LAST_MOD_KEY = 'lastModified';

export const FULLSTORY_API = intl.formatMessage({ defaultMessage: 'Fullstory API', id: 'NJDgAL' });

export const eventsTableColumns: TableColumnType<EventRow>[] = [
  {
    key: 'name',
    label: intl.formatMessage({ defaultMessage: 'Name', id: 'HAlOn1' }),
    sortable: true,
    renderCell: event => (
      <Text appearance="bodySmall" color={event.archived ? 'disabled' : undefined}>
        {event.name}
      </Text>
    ),
  },
  {
    key: EVENT_TABLE_LAST_MOD_KEY,
    label: intl.formatMessage({ defaultMessage: 'Last Modified', id: 'J8u7Xg' }),
    sortable: true,
    renderCell: event => {
      const text = () => {
        const lastUpdated = Timestamp.toDate(event.lastUpdated);
        const lastUpdatedBy =
          event.type === 'definedEvent'
            ? event.lastUpdatedBy
            : intl.formatMessage({ defaultMessage: 'Fullstory API', id: 'NJDgAL' });
        if (!lastUpdated && !lastUpdatedBy) {
          return '--';
        }
        const timestamp = lastUpdated?.toLocaleDateString() || '--';
        return `${timestamp}, ${lastUpdatedBy}`;
      };
      return (
        <Text appearance="bodySmall" color={event.archived ? 'disabled' : undefined}>
          {text()}
        </Text>
      );
    },
  },
];

export const propertyTypeLabels: { [K in FieldScope]: string } = {
  [FieldScope.NoScope]: 'Unknown',
  [FieldScope.User]: 'User',
  [FieldScope.Page]: 'Page',
  [FieldScope.Event]: 'Event',
  [FieldScope.Element]: 'Element',
  [FieldScope.Fsevt]: 'Fsevt',
};

export const MODAL_TABLE_MAX_HEIGHT = 420;

export const eventObjectType = intl.formatMessage({
  defaultMessage: 'event',
  id: 't6i3lC',
  description: 'An event originating from the Fullstory API',
});

export const testIds = {
  MODAL: 'api-event-modal',
  CLOSE_BUTTON: 'primary-button',
  ARCHIVE_BUTTON: 'tertiary-button',
};
